import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../../Accordion/Accordion.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

import data from "../../../Data/organizationMonitoring/organizationMonitoring.json";

export default function OrganizationMonitoring() {
  useSEO(seoConfig.organizationMonitoring);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Организация мониторинга качества образования
      </h1>

      <Accordion data={data} />
    </section>
  );
}
